import {Box, MenuItem, TextField} from '@mui/material';
import {bool, func} from 'prop-types';

import useBudget from '../../../../hooks/providers/useBudget';

const BudgetsSelect = ({onSelect, disabled = false}) => {
  const {alreadyTakenBudgetNames: budgets, selectedBudget} = useBudget();

  return (
    <Box mt={1} mb={2}>
      <TextField
        InputLabelProps={{shrink: true}}
        disabled={disabled}
        value={selectedBudget}
        onChange={e => onSelect(e.target.value)}
        fullWidth
        id="outlined-select-budget"
        select
        label="Choisissez un budget ..."
      >
        {budgets.length === 0 && (
          <MenuItem disabled value={null}>
            Pas de budget à modifier
          </MenuItem>
        )}
        {budgets.map(b => {
          return (
            <MenuItem key={b} value={b}>
              {b}
            </MenuItem>
          );
        })}
      </TextField>
    </Box>
  );
};

BudgetsSelect.propTypes = {
  onSelect: func.isRequired,
  disabled: bool
};

export default BudgetsSelect;
